<template>
    <div class="container" ref="headerBar" :style="{top: openInner ? '0px' : '-50px'}">
        <div class="process-bar" v-if="loadingStatus"></div>
        <div class="history">
            <div class="no-history" v-if="!cachedRoute.length">暂无历史页面记录</div>
            <div class="history-box">
                <div class="history-items" v-for="(aitem, aindex) in cachedRoute" :key="aindex" @click="onCachedRouteClick(aitem.meta.routeName)" :selected="$route.fullPath === aitem.meta.routeName">
                    <div v-for="(bitem, bindex) in aitem.meta.breadcrumb" :key="bindex">
                        <span>{{bitem}}</span>
                        <span class="slash" v-if="bindex < aitem.meta.breadcrumb.length - 1">/</span>
                    </div>
                    <a-icon class="close-icon" type="close-circle" @click.stop="unsetCachedRoute(aitem)" />
                </div>
            </div>
        </div>
        <div class="base-header">
            <div class="page-index">
                <div class="list-icon" @click="setMenuCollapse">
                    <a-icon type="unordered-list" />
                </div>
                <div class="tabtitle">
                    <a-breadcrumb>
                        <a-breadcrumb-item v-for="(item, index) in $route.meta.breadcrumb" :key="index">{{item}}</a-breadcrumb-item>
                    </a-breadcrumb>
                </div>
                <transition name="fade">
                    <div class="history-hint" :style="{color: headerRemindText[1], backgroundColor: `${headerRemindText[1]}30`}" v-if="headerRemindText.length">{{headerRemindText[0]}}</div>
                </transition>
            </div>
            <div class="user-manager">
                <div class="user-info">
                    <img class="avatar" src="../../assets/basic/avatar.png" />
                    <div class="username">
                        <a-dropdown>
                            <a class="ant-dropdown-link">
                                <span>{{userInfo.uname}}</span>
                                <a-icon type="down" />
                            </a>
                            <a-menu slot="overlay" @click="onUserOperation">
                                <a-menu-item key="user-info">
                                    <a>修改信息</a>
                                    <user-info-edit :show="showUserInfoEdit" @close="showUserInfoEdit = false"></user-info-edit>
                                </a-menu-item>
                                <a-menu-item key="exit">
                                    <a>退出登录</a>
                                </a-menu-item>
                            </a-menu>
                        </a-dropdown>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    mapState,
    mapMutations
} from 'vuex';
import UserInfoEdit from '@/common/required-components/user-info-edit'

export default {
    data() {
        return {
            showUserInfoEdit: false,
            onMouseStatus: false,
            openInner: false
        }
    },
    computed: {
        ...mapState('global', ['cachedRoute', 'loadingStatus', 'headerRemindText']),
        ...mapState('stored', ['userInfo'])
    },
    components: {
        UserInfoEdit
    },
    props: {},
    watch: {},
    created() { },
    mounted() {
        this.$refs.headerBar.onmousedown = () => {
            this.onMouseStatus = true
        }
        this.$refs.headerBar.onmouseup = this.$refs.headerBar.onmouseout = () => {
            this.onMouseStatus = false
        }
        this.$refs.headerBar.onmousemove = (e) => {
            if (this.onMouseStatus && e.movementY >= 5) {
                this.openInner = true
            } else if (this.onMouseStatus && e.movementY <= -5) {
                this.openInner = false
            }
        }
    },
    methods: {
        ...mapMutations('global', ['unsetCachedRoute', 'setMenuPermitted', 'setMenuCollapse', 'setHeaderRemindText']),
        ...mapMutations('stored', ['setUserInfo']),
        onUserOperation(e) {
            switch (e.key) {
            case 'user-info':
                this.showUserInfoEdit = true
                break
            case 'exit':
                this.setUserInfo({
                    uid: -1
                })
                this.setMenuPermitted([])
                break
            default:
                break
            }
        },
        onCachedRouteClick(e) {
            this.$util.common.toRoute(this.$route, this.$router, e)
            this.openInner = false
        }
    }
}
</script>

<style scoped lang="less">
@import "~@/style/animation.less";

.container {
    position: relative;
    height: 60px;
    transition: top 0.4s;
    user-select: none;
    z-index: 1000;

    .history {
        width: 100%;
        height: 50px;
        padding: 0px 16px;
        background-color: #eeeeee;
        display: flex;
        align-items: center;

        .no-history {
            font-weight: bold;
        }

        .history-box {
            display: flex;

            .history-items {
                display: flex;
                align-items: center;
                border: 1px solid lightgray;
                border-radius: 6px;
                padding: 4px 10px;
                margin: 0px 6px;

                .slash {
                    margin: 0px 10px;
                    font-weight: bold;
                }

                &:hover {
                    background-color: #d6d6d6;
                }

                &[selected],
                &[selected]:hover {
                    background-color: #c0c0c0;
                }

                .close-icon {
                    margin-left: 14px;
                }
            }
        }
    }

    .base-header {
        width: 100%;
        height: 60px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: white;
        position: relative;
        z-index: 100;
        box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.16);

        .process-bar {
            position: absolute;
            height: 100%;
            background: linear-gradient(
                to right,
                rgba(128, 128, 128, 0.2),
                white 150%
            );
            animation: process-animation 1s infinite;
            filter: blur(6px);
        }

        @keyframes process-animation {
            from {
                width: 0%;
            }

            to {
                width: 100%;
            }
        }

        .page-index {
            display: flex;
            z-index: 99;

            .fade-animation(1.5);

            .list-icon {
                margin: 0px 20px;
            }
        }

        .history-hint {
            margin-left: 32px;
            padding: 0px 10px;
            border-radius: 10px;
        }

        .user-manager {
            display: flex;
            align-items: center;
            position: relative;
            float: right;
            z-index: 99;

            .icon-set {
                width: 90px;
                display: flex;
                justify-content: space-around;
            }

            .user-info {
                display: flex;
                align-items: center;

                .avatar {
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    margin: 0px 10px;
                }

                .username {
                    margin-right: 20px;
                }
            }
        }
    }
}
</style>
